// components/pricing/TwoYearPlan.tsx
import React from 'react';

const TwoYearPlan: React.FC = () => {
  return (
    <>
      <p className="text-lg font-bold">Two Year</p>
      <p className="text-gray-500 line-through text-sm">$26.98/month</p>
      <p className="text-4xl font-extrabold text-gray-900">
        $13.49<span className="text-xl font-normal">/month</span>
      </p>
      <p className="text-gray-500 text-sm">billed every 2 years ($323.76)</p>
    </>
  );
};

export default TwoYearPlan;
